import type { AiIncident } from '../model/types';

export type Order = 'asc' | 'desc';

export type OrderBy = 'id' | 'title' | 'createdAt' | 'resolutionLevel';

const descendingComparator = (a: AiIncident, b: AiIncident, orderBy: OrderBy) => {
  const firstValue = a[orderBy];
  const secondValue = b[orderBy];

  if (secondValue === undefined || secondValue === null) {
    return -1;
  }

  if (firstValue === undefined || firstValue === null) {
    return 1;
  }

  if (secondValue < firstValue) {
    return -1;
  }

  if (secondValue > firstValue) {
    return 1;
  }

  return 0;
};

export const getComparator =
  (order: Order, orderBy: OrderBy) =>
  (a: AiIncident, b: AiIncident): number =>
    order === 'desc' ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
